import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from './cn';

/*
  Chip — фильтр-переключатель в панели инструментов: «Срочные», «Заблокированные», «PHP 8.1».
  Выбранный — инверсный (тёмный на светлом), чтобы набор включённых фильтров читался с первого
  взгляда; счётчик — табличными цифрами. Это не статус (статус — Badge) и не сущность (EntityChip).
*/

interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  count?: number;
  icon?: ReactNode;
}

export const Chip = forwardRef<HTMLButtonElement, ChipProps>(
  ({ selected, count, icon, className, children, ...rest }, ref) => (
    <button
      ref={ref}
      type="button"
      data-slot="chip"
      aria-pressed={selected}
      className={cn(
        'inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-xs font-medium whitespace-nowrap transition-colors duration-fast',
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-canvas focus-visible:outline-none',
        '[&_svg]:size-3.5 [&_svg]:shrink-0',
        selected
          ? 'border-transparent bg-fg text-fg-inverse'
          : 'border-line bg-card text-fg-muted hover:bg-hover hover:text-fg',
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
      {count !== undefined && (
        <span className={cn('tabular-nums', selected ? 'text-fg-inverse' : 'text-fg-subtle')}>{count}</span>
      )}
    </button>
  ),
);
Chip.displayName = 'Chip';
